<template>
  <div class="lxm-activity-feedback">

    <div class="page">
        <div class="lxm-activity-feedback__session-selector" v-if="state.sessionTimes && state.sessionTimes.length > 0">
          <select :value="state.selectedSessionTimeId" @change="onSessionChange" class="session-select">
            <option value="">全部场次</option>
            <option v-for="session in state.sessionTimes" :key="session.id" :value="session.id">
              {{ session.name }}
            </option>
          </select>
        </div>
        <lxm-switch-search :searchPlaceholder="'姓名/手机'"
                           :twoLetters="false"
                           @submit="searchSubmit"
                           @end="searchEnded">
          共<span class="lxm-activity-feedback__summary-number">{{ state.signedUpUserCount }}</span>人报名 已签到<span class="lxm-activity-feedback__summary-number">{{ state.signedInCount }}</span>人次
        </lxm-switch-search>
      <div class="lxm-activity-feedback__list">
          <lxm-activity-table :heads="tableHeads"
                              :rows="tableRows"
                              :activityId="activityId"
                              :tos="tableTos"></lxm-activity-table>
      </div>
      <lxm-more v-if="state.hasMore" :loading="loading" @click="moreClicked"></lxm-more>
    </div>

  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  .lxm-activity-feedback
    &>.page
      padding-top: 0
  .lxm-activity-feedback__summary-number
    color: brand-primary
    font-size: size-big
  .lxm-activity-feedback__list
    color: grey-dark
    border-radius: radius
    background-color: white
  .lxm-activity-feedback__session-selector
    padding: 10px 15px
    background-color: white
    .session-select
      width: 150px
      height: 30px
      background-color: #ff5348
      color: white
      border: none
      border-radius: 4px
      padding: 0 10px
      font-size: 14px
      cursor: pointer
      outline: none
      appearance: none
      -webkit-appearance: none
      -moz-appearance: none
      background-image: url('data:image/svg+xml;utf8,<svg fill="white" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>')
      background-repeat: no-repeat
      background-position: right 5px center
      background-size: 20px
      padding-right: 30px
      &:hover
        background-color: #e63d33
      option
        background-color: white
        color: #333
</style>

<script>
  /* eslint-disable comma-dangle */
  import LxmNav from '../common/LxmNav.vue'
  import LxmSwitchSearch from '../common/LxmSwitchSearch.vue'
  import LxmTable from '../common/LxmTable.vue'
  import LxmMore from '../common/LxmMore.vue'
  import LxmActivityTable from './LxmActivityTable.vue'
  import * as aTypes from '../../../store/action-types'
  export default {
    components: {
      LxmNav,
      LxmSwitchSearch,
      LxmTable,
      LxmMore,
      LxmActivityTable
    },
    data () {
      return {
        searching: false,
        showAttend: true,
        activityId: this.$route.query.activityId,
        isInitialLoad: true
      }
    },
    computed: {
      loading () {
        return this.$store.state.loading[aTypes.ACTIVITY_GET_FEEDBACK_LIST]
      },
      hasMore () {
        return this.$store.state.activity.feedback.hasMore
      },
      state () {
        return this.$store.state.activity.feedback
      },
      tableHeads () {
        return [
          '姓名',
          '手机',
          '签到'
        ]
      },
      title () {
        return this.state.title
      },
      tableRows () {
        return this.$store.state.activity.feedback.signupList.map(s => {
          return [
            s.form_data.name ? s.form_data.name : '',
            s.form_data.mobile ? s.form_data.mobile : '',
            { isSignButton: s.can_signin, isSigned: !s.can_signin, loading: s.loading, canSignout: s.can_signout, isCanceled: s.is_canceled, ticketNo: s.ticket_no ? s.ticket_no : '' }
          ]
        })
      },
      tableTos () {
        return this.$store.state.activity.feedback.signupList.map(s => {
          return {
            path: '/main/activity/feedback-detail',
            query: {
              activityId: this.$route.query.activityId,
              signupId: s.id
            }
          }
        })
      }
    },
    watch: {
      $route () {
        this.isInitialLoad = true
        // 立即清空旧数据，避免显示上一个活动的数据
        this.$store.commit('ACTIVITY_RESET_FEEDBACK')
        this.onMounted()
      },
      'state.title' (newVal, oldVal) {
        // 当活动标题变化时（说明获取了新活动数据），触发列表加载
        // 使用 title 作为触发条件，因为它一定会从空字符串变为有值
        if (this.isInitialLoad && newVal) {
          this.isInitialLoad = false
          this.$store.dispatch(aTypes.ACTIVITY_GET_FEEDBACK_LIST, {
            id: this.$route.query.activityId,
            page: 1,
            append: false,
            sessionTimeId: this.state.selectedSessionTimeId || undefined
          })
        }
      }
    },
    mounted () {
      // this.isInitialLoad = true
      // 首次进入页面时也清空数据，确保不显示其他活动的旧数据
      this.$store.commit('ACTIVITY_RESET_FEEDBACK')
      this.onMounted()
    },
    methods: {
      onMounted () {
        this.$store.dispatch(aTypes.GET_NOTIFICATION_STATUS, { type: 'activity_signup', id: this.$route.query.formId })
        this.$store.dispatch(aTypes.ACTIVITY_GET_FEEDBACK, this.$route.query.activityId)
        // this.fetchFirstPage()
      },
      moreClicked () {
        if (this.searching === false) {
          this.$store.dispatch(aTypes.ACTIVITY_GET_FEEDBACK_LIST, {
            id: this.$route.query.activityId,
            page: this.state.currentPage + 1,
            append: true,
            sessionTimeId: this.state.selectedSessionTimeId || undefined
          })
        } else {
          this.$store.dispatch(aTypes.ACTIVITY_GET_FEEDBACK_LIST, {
            id: this.$route.query.activityId,
            searchName: this.searching,
            page: this.state.currentPage + 1,
            append: true,
            sessionTimeId: this.state.selectedSessionTimeId || undefined
          })
        }
      },
      searchSubmit ({ value }) {
        this.showAttend = false
        this.searching = value
        this.$store.dispatch(aTypes.ACTIVITY_GET_FEEDBACK_LIST, {
          id: this.$route.query.activityId,
          searchName: value,
          page: 1,
          append: false,
          sessionTimeId: this.state.selectedSessionTimeId || undefined
        })
      },
      fetchFirstPage () {
        this.searching = false
        // 使用 selectedSessionTimeId
        const sessionTimeId = this.state.selectedSessionTimeId || undefined
        this.$store.dispatch(aTypes.ACTIVITY_GET_FEEDBACK_LIST, {
          id: this.$route.query.activityId,
          page: 1,
          append: false,
          sessionTimeId: sessionTimeId
        })
      },
      searchEnded () {
        this.fetchFirstPage()
      },
      onSessionChange (event) {
        // 更新 store 中的选择
        const sessionTimeId = event.target.value
        this.$store.commit('ACTIVITY_SET_SELECTED_SESSION_TIME_ID', sessionTimeId)
        // 场次切换时，重新获取统计数据和列表
        this.$store.dispatch(aTypes.ACTIVITY_GET_SIGNIN_STATISTICS, {
          activityId: this.$route.query.activityId,
          sessionTimeId: sessionTimeId || undefined
        })
        this.$store.dispatch(aTypes.ACTIVITY_GET_FEEDBACK_LIST, {
          id: this.$route.query.activityId,
          page: 1,
          append: false,
          sessionTimeId: sessionTimeId || undefined
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Feedback.vue?e54d7fae